import React, { useState, useEffect, useContext, useRef } from "react";
import { usePrivateChat } from "../hooks/usePrivateChat";
import { usePublicChat } from "../hooks/usePublicChat";
import { useCorporateChat } from "../hooks/useCorporateChat";
import { UserContext } from "../../../contexts/UserContext";
import { ChatContext } from "../../../contexts/ChatContext";

import ChatSlider from "./ChatSlider";
import ChatWindow from "../ChatWindow";
import { useRouter } from "next/router";
import { ScreenContext } from "../../../contexts/ScreenContext";
import { VIEWS } from "../../Views/MobileNavigationViews";

export default function ChatlistAllView({
  event,
  page,
  corporateOrganization,
}) {
  const MAX_INBOXES = 0;
  const router = useRouter()

  const { me } = useContext(UserContext);
  const { setinMobileView } = useContext(ScreenContext)
  const {
    initChatWindow,
    setInitChatWindow,
    unreadMessages,
    hasUnreadMessages,
    toggleChat,
    setToggleChat
  } = useContext(ChatContext);

  const [urlParams, setUrlParams] = useState(null);

  const [chatItem, setChatItem] = useState(null);
  const [allChatList, setAllChatList] = useState(null)
  const [latestMessageList, setLatestMessageList] = useState({})

  const { privateChatList, privateChatIndicatorList } = usePrivateChat({
    me,
    urlParams,
    maxOpenInboxes: MAX_INBOXES,
  });

  const { corporateChatList } = useCorporateChat({
    urlParams,
    me,
    corporateOrganization,
  });


  useEffect(() => {
    if (event && page) {
      setUrlParams({
        eventSlug: event,
        pageSlug: page,
        organizationSlug: corporateOrganization?.slug ?? "",
      });
    }
  }, [event, page, corporateOrganization]);

  //This will insert selected chat instance to chat slider
  const toggleChatWindow = (chatItem) => {
    if (chatItem) { 
     if (Array.isArray(chatItem)) {
        chatItem[1].props.forceOpen = false;
        chatItem[1].props.listItem = false;
      }
      setChatItem(chatItem);
      setToggleChat(true)
    } else {
      setChatItem(null);
      setToggleChat(false)
    }

  };

  const getColorByChatType = (type) => {
    switch (type) {
      case "public":
        return "chatlist-wrapper__item--public";

      case "private":
        return "chatlist-wrapper__item--private";

      case "corporate":
        return "chatlist-wrapper__item--private";

      default:
        return "";
    }
  };

  const getSortedPrivateChatList = () => {
    const sortedPrivateChatList = Object.entries(privateChatIndicatorList).sort(
      (chat1, chat2) => {
        return chat1[1].props.latestActivity > chat2[1].props.latestActivity;
      }
    );

    return sortedPrivateChatList;
  };

  const createChatArray = (initMount = false) => {
    let allChatList = [];

    if (corporateChatList !== null) {
      allChatList.push(...Object.entries(corporateChatList));
    }

    if (privateChatIndicatorList) {
      allChatList.push(...getSortedPrivateChatList());
    }

    allChatList.map((item) => {
      const [identifier, data] = item;
      const openChatIdentifier = chatItem?.[0];
      // Ignore all notifications if this chat is open
      if (identifier === openChatIdentifier) {
        item[1].props.unreadMessagesFilterFunction = () => false;
      }

      return item;
    });

    // if (latestMessageListCount === allChatListCount) allChatList = sortByLatestMessage(allChatList)

    return sortByLatestMessage(allChatList);
  };

  const sortByLatestMessage = (chatList) => {
    return chatList.sort((chat1, chat2) => {
      const [chat1ID] = chat1
      const [chat2ID] = chat2

      const chat1LatestMessage = latestMessageList?.[chat1ID]?.epoch
      const chat2LatestMessage = latestMessageList?.[chat2ID]?.epoch
      return chat2LatestMessage - chat1LatestMessage
    })
  }

  const allChatsInLatestMessageList = () => {
    const latestMessageListCount = Object.keys(latestMessageList).length
    const allChatListCount = allChatList.length

    return latestMessageListCount === allChatListCount
  }

  const handleSetLatestMessage = (inboxID, latestMessageTimestamp) => {
    setLatestMessageList((prevState) => ({ ...prevState, [inboxID]: latestMessageTimestamp }))
  }

  const getLatestChatItem = () => {
    const allChatList = getSortedPrivateChatList()
    const sortedByCreated = allChatList.sort((chat1, chat2) => {
      const [ chat1ID, chat1Data ] = chat1
      const [ chat2ID, chat2Data ] = chat2

      return chat1Data.createdAt - chat2Data.createdAt
    })

    return allChatList[allChatList.length - 1]
  } 

  useEffect(() => {
    if (initChatWindow) {
      setTimeout(() => {
        const newChatItem = getLatestChatItem()
        toggleChatWindow(newChatItem);
         setInitChatWindow(false);
      }, 250);
    }
  }, [privateChatList, privateChatIndicatorList]);

  useEffect(() => {
    setAllChatList(createChatArray());
  }, [
    corporateChatList,
    privateChatIndicatorList,
    chatItem,
    toggleChat,
    me,
    urlParams,
    event,
    page,
    latestMessageList
  ]);

  useEffect(() => {
    setinMobileView(VIEWS.home)
  }, [router.asPath])

  return (
    <>
      {me && urlParams && (
        <>
          <div className={`chatlist-wrapper ${allChatsInLatestMessageList() ? "" : "d-none"}`}>
            {allChatList &&
              allChatList.map((item, index) => {
                let primaryChatName = "";
                let restInfo = "";

                if (item[1].hasOwnProperty("members")) {
                  const members = item[1].members;

                  primaryChatName = Object.values(members)[0].first_name;

                  restInfo = Object.values(members).map(
                    (member) => `${member.first_name}, `
                  );
                } else {
                  item.primaryChatName = "Live Chat";
                  item.restInfo = "";
                }

                return (
                  <ChatWindow {...item[1]?.props} onSetLatestMessage={(latestMessage) => handleSetLatestMessage(item[0], latestMessage)}>
                    {(props) => {
                      return (
                        <>
                          <div
                            key={index}
                            className={`chatlist-wrapper__item ${getColorByChatType(
                              props.type
                            )}`}
                            onClick={() => {
                              toggleChatWindow(item);
                        
                            }}
                          >
                            <div className="chatlist-wrapper__item-info">
                              <h3>
                                {props.type === "public"
                                  ? item.primaryChatName
                                  : props.listItemTitle
                                    ? props.listItemTitle
                                    : props.tabTitle}
                              </h3>
                              <p>{item.restInfo} {latestMessageList?.[item[0]]?.message}</p>
                            </div>

                            {props.unreadMessageCount > 0 && (
                              <div className="chatlist-wrapper__item-indicator">
                                {props.unreadMessageCount}
                              </div>
                            )}
                          </div>
                        </>
                      );
                    }}
                  </ChatWindow>
                );
              })}
          </div>
          {/* {
          <p style={{color:"#A8A8A8", textAlign:"center", fontSize:"12px"}}>Loading...</p>} */}

          <ChatSlider
            toggleChatWindow={toggleChatWindow}
            chatItem={chatItem}
          />
        </>
      )}
    </>
  );
}
